export function scrollToDOMElement(element, behavior = "smooth") {
  window.scrollTo({
    top: element.getBoundingClientRect().top + window.scrollY,
    behavior,
  });
}
